import { render, staticRenderFns } from "./AdminClassTutorial.vue?vue&type=template&id=281651e3&scoped=true&"
import script from "./AdminClassTutorial.vue?vue&type=script&lang=js&"
export * from "./AdminClassTutorial.vue?vue&type=script&lang=js&"
import style0 from "./AdminClassTutorial.vue?vue&type=style&index=0&id=281651e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281651e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VContainer,VFlex,VLayout,VProgressCircular,VTextField})
